export function getBacTypeAccordingToName(bacName: string): string {
  switch (bacName) {
    case '__MUSIC__':
      return 'music';
    case '__IDENTIFICATION__':
      return 'identification';
    case '__PODCAST__':
      return 'podcast';
    case '__AD__':
      return 'ad';
    case '__CHRONIC__':
      return 'chronic';
    case '__DEDICATION__':
      return 'dedication';
    default:
      return 'music';
  }
}
